import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Loader from './Loader';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();

  console.log('PrivateRoute - Auth State:', { isAuthenticated, loading, user });
  console.log('PrivateRoute - User role:', user?.role);

  if (loading) {
    return <Loader fullScreen text="Loading..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // SUPER ADMIN - allow access to everything
  if (user?.role === 'Super Admin') {
    console.log('✅ Super Admin detected - allowing access to all routes');
    return children;
  }

  // For business users, check subscription
  if (user?.subscription_status !== 'active' && user?.subscription_status !== 'trial') {
    console.log('❌ Subscription expired - redirecting');
    return <Navigate to="/subscription-expired" replace />;
  }

  return children;
};

export default PrivateRoute;